import type { Template } from "@/types";

export const PO_05_H4_V1: Template[] = [
    {
        id: "po-05-h4v1-01",
        name: "PO 01 - H4V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h4_v1_01.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 64, y: 250, width: 520, height: 326, rotation: 0, imageRotation: 0 },       
            { id: "2", x: 717, y: 206, width: 212, height: 133, rotation: 0, imageRotation: 0 },
            { id: "3", x: 717, y: 347, width: 212, height: 133, rotation: 0, imageRotation: 0 },
            { id: "4", x: 717, y: 488, width: 212, height: 133, rotation: 0, imageRotation: 0 },
            { id: "5", x: 937, y: 206, width: 298, height: 415, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h4v1-02",
        name: "PO 02 - H4V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h4_v1_02.png",
        size: [1298, 827],
        style: {},
        slots: [         
            { id: "1", x: 197, y: 84, width: 256, height: 159, rotation: 0, imageRotation: 0 },
            { id: "2", x: 197, y: 251, width: 256, height: 158, rotation: 0, imageRotation: 0 },
            { id: "3", x: 197, y: 417, width: 256, height: 158, rotation: 0, imageRotation: 0 },
            { id: "4", x: 197, y: 583, width: 256, height: 158, rotation: 0, imageRotation: 0 },
            { id: "5", x: 749, y: 84, width: 450, height: 657, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h4v1-03",
        name: "PO 03 - H4V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h4_v1_03.png",
        size: [1298, 827],
        style: {},
        slots: [         
            { id: "1", x: 35, y: 209, width: 318, height: 202, rotation: 0, imageRotation: 0 },
            { id: "2", x: 35, y: 419, width: 318, height: 201, rotation: 0, imageRotation: 0 },
            { id: "3", x: 361, y: 0, width: 576, height: 827, rotation: 0, imageRotation: 0 },
            { id: "4", x: 945, y: 209, width: 318, height: 202, rotation: 0, imageRotation: 0 },
            { id: "5", x: 945, y: 419, width: 318, height: 201, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h4v1-04",
        name: "PO 04 - H4V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h4_v1_04.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 28, y: 158, width: 597, height: 379, rotation: 0, imageRotation: 0 },       
            { id: "2", x: 28, y: 545, width: 194, height: 125, rotation: 0, imageRotation: 0 },
            { id: "3", x: 230, y: 545, width: 194, height: 125, rotation: 0, imageRotation: 0 },
            { id: "4", x: 432, y: 545, width: 193, height: 125, rotation: 0, imageRotation: 0 },
            { id: "5", x: 792, y: 158, width: 365, height: 512, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h4v1-05",
        name: "PO 05 - H4V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h4_v1_05.png",
        size: [1298, 827],
        style: {},
        slots: [         
            { id: "1", x: 33, y: 322, width: 292, height: 184, rotation: 0, imageRotation: 0 },
            { id: "2", x: 333, y: 322, width: 291, height: 184, rotation: 0, imageRotation: 0 },
            { id: "3", x: 187, y: 132, width: 292, height: 183, rotation: 0, imageRotation: 0 },
            { id: "4", x: 187, y: 514, width: 292, height: 182, rotation: 0, imageRotation: 0 },
            { id: "5", x: 775, y: 132, width: 396, height: 564, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h4v1-06",
        name: "PO 06 - H4V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h4_v1_06.png",
        size: [1298, 827],
        style: {},
        slots: [        
            { id: "1", x: 0, y: 343, width: 218, height: 139, rotation: 0, imageRotation: 0 },
            { id: "2", x: 226, y: 343, width: 218, height: 139, rotation: 0, imageRotation: 0 },
            { id: "3", x: 452, y: 131, width: 394, height: 564, rotation: 0, imageRotation: 0 },
            { id: "4", x: 854, y: 343, width: 218, height: 139, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1080, y: 343, width: 218, height: 139, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h4v1-07",
        name: "PO 07 - H4V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h4_v1_07.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 579, height: 827, rotation: 0, imageRotation: 0 },
            { id: "2", x: 714, y: 188, width: 517, height: 327, rotation: 0, imageRotation: 0 },
            { id: "3", x: 714, y: 523, width: 168, height: 116, rotation: 0, imageRotation: 0 },
            { id: "4", x: 890, y: 523, width: 167, height: 116, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1065, y: 523, width: 167, height: 116, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h4v1-08",
        name: "PO 08 - H4V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h4_v1_08.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 80, y: 64, width: 490, height: 699, rotation: 0, imageRotation: 0 },
            { id: "2", x: 701, y: 241, width: 269, height: 169, rotation: 0, imageRotation: 0 },
            { id: "3", x: 701, y: 418, width: 269, height: 168, rotation: 0, imageRotation: 0 },
            { id: "4", x: 978, y: 241, width: 268, height: 169, rotation: 0, imageRotation: 0 },
            { id: "5", x: 978, y: 418, width: 268, height: 168, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h4v1-09",
        name: "PO 09 - H4V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h4_v1_09.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 0, y: 215, width: 606, height: 397, rotation: 0, imageRotation: 0 },
            { id: "2", x: 614, y: 215, width: 398, height: 265, rotation: 0, imageRotation: 0 },          
            { id: "3", x: 614, y: 488, width: 195, height: 124, rotation: 0, imageRotation: 0 },
            { id: "4", x: 817, y: 488, width: 195, height: 124, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1020, y: 215, width: 278, height: 397, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h4v1-10",
        name: "PO 10 - H4V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h4_v1_10.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 0, y: 212, width: 191, height: 127, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 347, width: 389, height: 267, rotation: 0, imageRotation: 0 },
            { id: "3", x: 199, y: 212, width: 190, height: 127, rotation: 0, imageRotation: 0 },
            { id: "4", x: 397, y: 212, width: 615, height: 402, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1020, y: 212, width: 279, height: 402, rotation: 0, imageRotation: 0 },
              
        ],
    }
];